import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { compose, setDisplayName } from 'recompose';

import {
  SmartDialog,
  SmartForm,
} from 'components';
import { sendNewPasswordLink } from 'redux/auth/actions';

const styles = () => ({
  root: {
    '&:disabled': {
      color: '#4695ec',
    },
  },
  disabled: {},
});

class ForgotPasswordDialog extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    classes: PropTypes.shape({}),
    formatMessage: PropTypes.func.isRequired,
    sendNewPasswordLink: PropTypes.func.isRequired,
  };

  static defaultProps = {
    disabled: false,
    classes: {},
  };

  state = { open: false };

  onClose = () => this.setState({ open: false });

  onOpen = () => this.setState({ open: true });

  onSave = (data) => {
    const { sendNewPasswordLink } = this.props;
    data.email = data.email.trim();
    sendNewPasswordLink({
      ...data,
      onSuccess: this.onClose,
    });
  }

  render() {
    const { disabled, formatMessage, classes } = this.props;
    const { open } = this.state;
    const fields = [
      {
        kind: 'input',
        label: formatMessage('Enter Your Email'),
        name: 'email',
        required: true,
        fullWidth: true,
        inputProps: { 
          autoCapitalize: 'none',
        }
      },
    ];
    return (
      <div>
        <Button
          disabled={disabled}
          onClick={this.onOpen}
          variant="text"
          color="primary"
          classes={{
            root: classes.root,
            disabled: classes.disabled,
          }}
          type="button"
        >
          {formatMessage('Reset Password')}
        </Button>
        <SmartDialog
          onClose={this.onClose}
          open={open}
          title={formatMessage('Set New Password')}
        >
          <SmartForm
            cancelButton={formatMessage('Cancel')}
            fields={fields}
            onCancel={this.onClose}
            onSave={this.onSave}
            saveButton={formatMessage('Email New Password Link')}
          />
        </SmartDialog>
      </div>
    );
  }
}

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  sendNewPasswordLink: payload => dispatch(sendNewPasswordLink(payload)),
});

export default compose(
  setDisplayName('ForgotPasswordDialog'),
  connect(
    undefined,
    mapDispatchToProps,
  ),
  withStyles(styles),
)(ForgotPasswordDialog);
